import React, { useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import useUrlEntities from "core/shared/hooks/useUrlEntities";

const AccountSelectorContext = React.createContext({});

const { Provider } = AccountSelectorContext;

// Treat as read  only (will not impact account selector state)
export const useAccountSelectorEntities = () => {
  const {
    advertiserId,
    advertiserName,
    agencyId,
    agencyName,
    organizationId,
    organizationName,
    setContextEntities,
  } = useContext(AccountSelectorContext);

  return {
    advertiserId,
    advertiserName,
    agencyId,
    agencyName,
    organizationId,
    organizationName,
    setContextEntities,
  };
};

export const AccountSelectorProvider = ({ children = null }) => {
  const {
    organizationId: initialOrgId,
    agencyId: initialAgyId,
    advertiserId: initialAdvId,
  } = useUrlEntities();
  const [organizationId, setOrganizationId] = useState(initialOrgId);
  const [organizationName, setOrganizationName] = useState();
  const [agencyId, setAgencyId] = useState(initialAgyId);
  const [agencyName, setAgencyName] = useState();
  const [advertiserId, setAdvertiserId] = useState(initialAdvId);
  const [advertiserName, setAdvertiserName] = useState();

  const setContextEntities = useCallback(
    ({
      advertiserId: newAdvId,
      advertiserName: newAdvName,
      agencyId: newAgyId,
      agencyName: newAgyName,
      organizationId: newOrgId,
      organizationName: newOrgName,
    }) => {
      setOrganizationId(newOrgId);
      setOrganizationName(newOrgName);
      setAgencyId(newAgyId);
      setAgencyName(newAgyName);
      setAdvertiserId(newAdvId);
      setAdvertiserName(newAdvName);
    },
    []
  );

  const value = {
    advertiserId,
    advertiserName,
    agencyId,
    agencyName,
    organizationId,
    organizationName,
    setContextEntities,
  };

  return <Provider value={value}>{children}</Provider>;
};

AccountSelectorProvider.propTypes = {
  children: PropTypes.node,
};
